import { render } from "./AssignTrainees.vue?vue&type=template&id=69b32308&scoped=true"
import script from "./AssignTrainees.vue?vue&type=script&lang=js"
export * from "./AssignTrainees.vue?vue&type=script&lang=js"

import "./AssignTrainees.vue?vue&type=style&index=0&id=69b32308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b32308"]])

export default __exports__